<script lang="ts">
  type HeaderLevel = "1" | "2" | "3" | "4";
  const levelTagMap = {
    "1": "h1",
    "2": "h2",
    "3": "h3",
    "4": "h3",
  };
  const levelTextSizeMap = {
    "1": "text-[20px]",
    "2": "text-[17px]",
    "3": "text-[15px]",
    "4": "text-[14px]",
  };
  export let size: HeaderLevel;
  export let bold: boolean = false;

  export let light: boolean = false;

  let Tag = levelTagMap[size];
  let textSize = levelTextSizeMap[size];
</script>

<svelte:element
  this={Tag}
  class:font-bold={bold}
  class:text-grey-80={!light}
  class:text-greenGrey-60={light}
  class={`content-center ${textSize}`}
>
  <slot />
</svelte:element>
